import {
    INITIATE_PAYMENT_REQUEST,
    INITIATE_PAYMENT_SUCCESS,
    INITIATE_PAYMENT_FAILURE
} from '../PlanDetails/plan-actions';

const initialState = {
    loading: false,
    error: null
};

export const paymentReducer = (state = initialState, action) => {
    switch (action.type) {
        case INITIATE_PAYMENT_REQUEST:
            return { ...state, loading: true, error: null };
        case INITIATE_PAYMENT_SUCCESS:
            return { ...state, loading: false };
        case INITIATE_PAYMENT_FAILURE:
            return { ...state, loading: false, error: action.error };
        default:
            return state;
    }
};
